import React from "react";
import {
  Text,
  View,
  Document as _document,
  Page as _page,
  StyleSheet,
} from "@react-pdf/renderer";
import FormatTime from "../../../helpers/FormatTime";
import FormatDateTime from "../../../helpers/FormatDateTime";

const Document = _document;
const Page = _page;

const styles = StyleSheet.create({
  pagina: {
    // fontFamily: "Tinos",
    padding: "25 15 25 15",
    display: "flex",
    justifyContent: "space-between",
  },
  header: {
    position: "relative",
  },
  data: {
    flex: 1,
    marginBottom: 40,
  },
  rodape: {
    fontSize: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    borderTop: "1pt solid black",
    paddingTop: 5,
    marginTop: 5,
  },
});

const PorClienteDescricaoCompletaInternaPDF = ({ dados, user }) => {
  return (
    <Document>
      <Page style={styles.pagina} orientation="portrait">
        <View style={styles.header} fixed>
          <View style={{ width: "100%", alignItems: "center" }}>
            <View style={{ alignItems: "center" }}>
              <Text style={{ fontSize: 11 }}>{dados.cabecalho.empresa}</Text>
              <Text style={{ fontSize: 11 }}>{dados.cabecalho.titulo}</Text>
            </View>
          </View>

          {dados.cabecalho.filtros && (
            <View
              style={{
                fontSize: 9,
                width: "100%",
                alignItems: "center",
                flexDirection: "row",
                marginBottom: 5,
                marginTop: 5,
              }}
            >
              <View
                style={{
                  width: "10%",
                  height: "100%",
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                  marginRight: "5px",
                }}
              >
                <Text>Filtros:</Text>
              </View>
              <View
                style={{
                  width: "90%",
                  alignItems: "flex-start",
                  justifyContent: "center",
                }}
              >
                {dados.cabecalho.filtros.periodo && (
                  <View>
                    <Text>
                      <Text style={{ fontFamily: "Helvetica-Bold" }}>
                        {"Período: "}
                      </Text>
                      {`${dados.cabecalho.filtros.periodo}`}
                    </Text>
                  </View>
                )}
                {dados.cabecalho.filtros.pessoa && (
                  <View>
                    <Text>
                      <Text style={{ fontFamily: "Helvetica-Bold" }}>
                        {"Cliente: "}
                      </Text>
                      {dados.cabecalho.filtros.pessoa}
                    </Text>
                  </View>
                )}
                {dados.cabecalho.filtros.plataformaSistema && (
                  <View>
                    <Text>
                      <Text style={{ fontFamily: "Helvetica-Bold" }}>
                        {"Plataforma/Sistema: "}
                      </Text>
                      {dados.cabecalho.filtros.plataformaSistema}
                    </Text>
                  </View>
                )}
                {dados.cabecalho.filtros.moduloFuncionalidade && (
                  <View>
                    <Text>
                      <Text style={{ fontFamily: "Helvetica-Bold" }}>
                        {"Módulo/Funcionalidade: "}
                      </Text>
                      {dados.cabecalho.filtros.moduloFuncionalidade}
                    </Text>
                  </View>
                )}
                {dados.cabecalho.filtros.motivoClassificacao && (
                  <View>
                    <Text>
                      <Text style={{ fontFamily: "Helvetica-Bold" }}>
                        {"Motivo (Classificação): "}
                      </Text>
                      {dados.cabecalho.filtros.motivoClassificacao}
                    </Text>
                  </View>
                )}
                {dados.cabecalho.filtros.slaPrioridade && (
                  <View>
                    <Text>
                      <Text style={{ fontFamily: "Helvetica-Bold" }}>
                        {"Sla Prioridade: "}
                      </Text>
                      {dados.cabecalho.filtros.slaPrioridade}
                    </Text>
                  </View>
                )}
                {dados.cabecalho.filtros.descricao && (
                  <View>
                    <Text>
                      <Text style={{ fontFamily: "Helvetica-Bold" }}>
                        {"Descrição do Ticket: "}
                      </Text>
                      {dados.cabecalho.filtros.descricao}
                    </Text>
                  </View>
                )}
                {dados.cabecalho.filtros.usuario && (
                  <View>
                    <Text>
                      <Text style={{ fontFamily: "Helvetica-Bold" }}>
                        {"Usuário: "}
                      </Text>
                      {dados.cabecalho.filtros.usuario}
                    </Text>
                  </View>
                )}
              </View>
            </View>
          )}

          <View
            style={{
              position: "absolute",
              width: "100%",
              alignItems: "flex-end",
            }}
          >
            <Text
              style={{ fontSize: 9 }}
              render={({ pageNumber, totalPages }) =>
                `Página ${pageNumber} de ${totalPages}`
              }
              fixed
            />
          </View>
        </View>

        <View style={{ fontSize: 8, width: "100%", flex: 1, marginBottom: 20 }}>
          <View
            fixed
            style={{
              flexDirection: "row",
              borderBottom: "1pt solid black",
              fontSize: 9,
              fontFamily: "Helvetica-Bold",
            }}
          >
            <View style={{ width: "20%", alignItems: "flex-start" }}>
              <Text>Data</Text>
            </View>
            <View style={{ width: "1%" }} />

            <View style={{ width: "8%", alignItems: "flex-start" }}>
              <Text>Número</Text>
            </View>
            <View style={{ width: "1%" }} />

            <View style={{ width: "48%", alignItems: "flex-start" }}>
              <Text>Descrição (Título)</Text>
            </View>
            <View style={{ width: "1%" }} />

            <View style={{ width: "20%", alignItems: "flex-end" }}>
              <Text>Tempo Real</Text>
            </View>
            <View style={{ width: "1%" }} />
          </View>

          {dados.dados.map((item) => {
            return (
              <View key={item.chave.pessoaId}>
                <Text
                  style={{
                    marginTop: 2,
                    marginBottom: 2,
                    fontFamily: "Helvetica-Bold",
                  }}
                >
                  {`Cliente: `}
                  {item.chave.pessoaClienteCodigoNome}
                </Text>

                {item.listaDados.map((dado, index) => {
                  return (
                    <View
                      key={dado.id}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#E4E4E4" : "#fff",
                      }}
                    >
                      <View style={{ flexDirection: "row" }}>
                        <View
                          style={{ width: "20%", alignItems: "flex-start" }}
                        >
                          <Text>{FormatDateTime(dado.dataHora, false)}</Text>
                        </View>
                        <View style={{ width: "1%" }} />

                        <View style={{ width: "8%", alignItems: "flex-start" }}>
                          <Text>{dado.id}</Text>
                        </View>
                        <View style={{ width: "1%" }} />

                        <View
                          style={{ width: "48%", alignItems: "flex-start" }}
                        >
                          <Text>{dado.descricao}</Text>
                        </View>
                        <View style={{ width: "1%" }} />

                        <View style={{ width: "20%", alignItems: "flex-end" }}>
                          <Text>
                            {FormatTime(dado.tempoReal) ?? "00:00:00"}
                          </Text>
                        </View>
                        <View style={{ width: "1%" }} />
                      </View>
                      {dado.descricaoCompleta && (
                        <Text
                          style={{
                            marginTop: 3,
                            marginBottom: 3,
                          }}
                        >
                          {`Descrição Completa: ${dado.descricaoCompleta}`}
                        </Text>
                      )}
                      {dado.descricaoInterna && (
                        <Text
                          style={{
                            marginTop: 3,
                            marginBottom: 3,
                          }}
                        >
                          {`Descrição Interna: ${dado.descricaoInterna}`}
                        </Text>
                      )}
                    </View>
                  );
                })}

                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 5,
                    marginBottom: 2,
                    fontFamily: "Helvetica-Bold",
                  }}
                >
                  <View style={{ width: "70%", alignItems: "flex-start" }}>
                    <Text>
                      {`Total de chamados por Cliente: `}
                      {item.chave.totalTicketsPorCliente}
                    </Text>
                  </View>
                  <View style={{ width: "29%", alignItems: "flex-end" }}>
                    <Text>{item.chave.totalTempoPorCliente}</Text>
                  </View>
                  <View style={{ width: "1%" }} />
                </View>

                <View
                  style={{ borderBottom: "1pt dashed black", width: "100%" }}
                />
              </View>
            );
          })}
          <View
            style={{
              display: "flex",
              borderBottom: "1pt solid black",
              marginTop: "2pt",
              marginBottom: "2pt",
              paddingTop: "2pt",
              flexDirection: "row",
              fontSize: 9,
            }}
          >
            <View style={{ width: "70%" }}>
              <Text style={{ marginTop: 5, fontFamily: "Helvetica-Bold" }}>
                {`Total de chamados: `}
                {dados.totalTickets}
              </Text>
            </View>
            <View style={{ width: "29%", alignItems: "flex-end" }}>
              <Text style={{ marginTop: 5, fontFamily: "Helvetica-Bold" }}>
                {dados.totalTempo}
              </Text>
            </View>
            <View style={{ width: "1%" }} />
          </View>
        </View>

        <View fixed style={styles.rodape}>
          <Text>{`Impresso por ${user.name} em ${FormatDateTime(
            new Date(),
            false
          )}.`}</Text>

          <Text>https://ticket.elogestor.com.br/</Text>
        </View>
      </Page>
    </Document>
  );
};

export default PorClienteDescricaoCompletaInternaPDF;
